import React, { useState } from 'react'
import './cards.css'
import account_img from '../../assets/images/document.png'
import useClickOutside from '../../useClickOutside'
import moment from 'moment'
import { formatNumberWithCommas } from '../general/general-component/abstruct-component/FunctionRemoveCommas'
import { useSelectorCustom } from '../general/general-component/abstruct-component/useSelectorCustom'

function AccountCard({translate,openAddTransaction,detailsOfAccount,warning,handleEdit, account,langLocal,index,goToReport }) {
    const [options, setOptions] = useState(false)
    const { currency } = useSelectorCustom();
    const [row_id, setRowId] = useState(null)
    let domNode = useClickOutside(() => {
        setOptions(false);
        setRowId(null)
    });
    return (
        <div className='one-account card-hover'>
            <div className={`one-account-img`} >
                <img src={account_img} className={langLocal =='ar' ? "margin_left_35": "margin_right_35"} />
                <div className='right-one-account' >
                    <div className='div-one-account'>
                        <div className='span-one-account'>{translate('id')}</div>
                        <span>{account?.id}</span>
                    </div>
                    <div className='div-one-account'>
                        <div className='span-one-account'>{translate('name')}</div>
                        <span>{account?.name}</span>
                    </div>
                    <div className='div-one-account'>
                        <div className='span-one-account'>{translate('amount')} </div>
                        <span>{ formatNumberWithCommas(account?.amount) } {' '} {translate(currency)}</span>
                    </div>
                </div>
            </div>
            <div style={{ marginTop: "21px" }} >
                <div className='one-account-bottom'  >
                    <div className='div-one-account-bottom' style={{ width: "48%" }} >
                        <div style={{ display: "flex", alignItems: "center", width: "45%" }} >
                            <div className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_15"} circle-div-info`}></div>
                            <span className='span-one-account1' >{translate('type')}</span>
                        </div>
                        <span className='div-one-account-span' >{account?.type}</span>
                    </div>
                    <div className='div-one-account-bottom' style={{ width: "48%" }} >
                        <div style={{ display: "flex", alignItems: "center", width: "45%" }} >
                            <div className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_15"} circle-div-info`}></div>
                            <span className='span-one-account1'>{translate('created_by')}</span>
                        </div>
                        <span className='div-one-account-span' >{account?.created_by?.name}</span>
                    </div>
                </div>
                <div className='one-account-bottom'  >
                    <div className='div-one-account-bottom' style={{ width: "48%" }} >
                        <div style={{ display: "flex", alignItems: "center", width: "45%" }} >
                            <div className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_15"} circle-div-info`}></div>
                            <span className='span-one-account1'>{translate('created_at')}</span>
                        </div>
                        <span className='div-one-account-span' >{moment(account?.created_at).format("YYYY-MM-DD")}</span>
                    </div>
                    <div className='div-one-account-bottom' style={{ width: "48%" }} >
                        <div style={{ display: "flex", alignItems: "center", width: "100%" }} >
                            <div style={{ backgroundColor: "#ff5e5bef" }} className={` ${langLocal === 'ar' ? "margin_left_10" : "margin_right_15"} circle-div-info`}></div>
                            <span className='more-details-account' onClick={() => {setOptions(!options);setRowId(index)}} >{translate('select_more_actions')}</span>
                        </div>
                    </div>
                </div>
            </div>
            {
                options && index === row_id && (
                    <div ref={domNode} className='div-actions shadow_main2' 
                    style={langLocal==='ar'? {left: "50px",marginTop: "10px"}:{right: "50px",marginTop: "10px"}} >
                        <span onClick={(e) => handleEdit(e, account)} >{translate('edit')}</span>
                        <span onClick={() => warning(account)} >{translate('delete')}</span>
                        <span onClick={() => detailsOfAccount(account?.id)} >{translate('details')}</span>
                        <span onClick={() => goToReport(account?.id)}>{translate('report')}</span>
                        <span>{translate('block')}</span>
                        <span onClick={(e) => openAddTransaction(e, account?.id)} >{translate('add_transaction')}</span>
                    </div>
                )
            }
        </div>
    )
}

export default AccountCard